export const formatAddress = (inAddress, cut = 7) => {
    if(!inAddress || inAddress.length < cut * 2) {
        return inAddress
    } else {
        return inAddress.substring(0, cut) + "..." + inAddress.substring(inAddress.length - cut, inAddress.length)
    }
}